// Footer.js — BerBul design system · matches TradeDashboard tokens
import React from "react";

const C = {
  bg1:    "#0c1525",
  border: "#1e2d42",
  meta:   "#6a7d95",
  cyan:   "#00c8ff",
};

const FONT = "'DM Mono', monospace";

function Footer() {
  return (
    <footer style={{
      background:   C.bg1,
      borderTop:    `1px solid ${C.border}`,
      padding:      "16px 32px",
      display:      "flex",
      alignItems:   "center",
      justifyContent: "space-between",
    }}>
      <span style={{ fontFamily: FONT, fontSize: 9, color: C.meta, letterSpacing: ".5px" }}>
        © {new Date().getFullYear()}{" "}
        <span style={{ color: C.cyan, fontWeight: 500 }}>BERBUL.AI</span>
        {" "}· PAPER ACCOUNT · SPY 0DTE
      </span>
      <span style={{ fontFamily: FONT, fontSize: 9, color: C.meta, letterSpacing: ".5px" }}>
        BROKER-INTEGRATED EXECUTION · EXPLAINABLE AUTONOMY
      </span>
    </footer>
  );
}

export default Footer;